// @noflow
import type { TextProps } from '@/components/elements/atoms/Text'

import type { EditDailyAmountQuery_user_subscription_plan as Plan } from '../queries/__generated__/EditDailyAmountQuery'

type DailyAmountOption = {
  id: string
  typography: TextProps | Array<TextProps>
}

const getDailyAmount = (plan: Plan): number =>
  plan.servingInformation.gramsPerDay

const createDailyAmountOptionsFromPlans = (
  plans: Array<Plan> | null
): Array<DailyAmountOption> => {
  if (!plans) return []

  // Sort plans by daily amount
  const sortedPlans = [...plans].sort(
    (a, b) => getDailyAmount(a) - getDailyAmount(b)
  )

  // Create a Set to track which daily amounts we've displayed
  const displayedAmounts = new Set<number>()

  // Create options, but only display one per unique daily amount
  return sortedPlans
    .filter((plan) => {
      const dailyAmount = getDailyAmount(plan)
      if (displayedAmounts.has(dailyAmount)) {
        return false
      }
      displayedAmounts.add(dailyAmount)
      return true
    })
    .map((plan) => ({
      id: plan.id,
      typography: [
        {
          variant: 'display28',
          colour: 'brandBlue500',
          text: 'edit_daily_amount.daily_calorie_guidance.option_selector.option.text1',
          namespace: 'account',
          variables: {
            gramsPerDay: getDailyAmount(plan)
          },
          align: 'center'
        },
        {
          variant: 'textRegular16',
          colour: 'brandBlue400',
          text: 'edit_daily_amount.daily_calorie_guidance.option_selector.option.text2',
          namespace: 'account',
          variables: {
            roundedCaloriesPerDay: plan.servingInformation.roundedCaloriesPerDay
          },
          align: 'center'
        }
      ]
    }))
}

export type { DailyAmountOption }

export { getDailyAmount, createDailyAmountOptionsFromPlans }
